import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { SupplierHoverCard } from '@/features/shared/supplier-hover-card';
import type { Supplier } from '@/types/core/purchase-planning/supplier';

type LotSizingInfoSupplierProps = {
  suppliers: Supplier[];
};

export function LotSizingInfoSupplier({
  suppliers,
}: LotSizingInfoSupplierProps) {
  const { t } = useTranslation('lotSizing');
  const [showAllSuppliers, setShowAllSuppliers] = useState(false);
  const previewCount = 3;
  const visibleSuppliers = showAllSuppliers
    ? suppliers
    : suppliers.slice(0, previewCount);

  return (
    <>
      <span className='flex flex-col gap-1'>
        {visibleSuppliers.map((supplier) => (
          <SupplierHoverCard key={supplier.id} supplier={supplier} />
        ))}
      </span>
      {suppliers.length > previewCount && (
        <Button
          className='mt-1 h-auto p-0'
          onClick={() => setShowAllSuppliers((prev) => !prev)}
          size='sm'
          type='button'
          variant='link'
        >
          {showAllSuppliers
            ? t('showLess')
            : t('showMore', {
                count: suppliers.length - previewCount,
              })}
        </Button>
      )}
    </>
  );
}
